import { Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import AddButton from "../../components/buttons/button";
import "../../components/customer-information/customer-information.css";
import CheckBox from "../../components/forms/check-box-field";
import InputField from "../../components/forms/input-field";
import RadioButton from "../../components/forms/radio-button";
import SelectField from "../../components/forms/select-field";
import TextAreaField from "../../components/forms/textarea-field";
import errorToast from "../../components/helper-components/error-toast";
import { hsnRegExp } from "../../components/helper-components/regexp";
import successToast from "../../components/helper-components/success-toast";
import InnerLayout from "../../components/layouts/inner-layout";
import InventoryTab from "../../components/product-information/inventory-tab";
import PlanningTab from "../../components/product-information/planning-tab";
import PurchasingTab from "../../components/product-information/purchasing-tab";
import RemarksTab from "../../components/product-information/remarks-tab";
import RestrictionsTab from "../../components/product-information/restrictions-tab";
import SalesTab from "../../components/product-information/sales-tab";
import {
  catListAction,
  interTaxCatListAction,
  itemGroupListAction,
  itemTypeListAction,
  manufacturesListAction,
  manufacturerFuzzySearchAction,
  priceListAction,
  schListAction,
  sectorListAction,
  shippingTypeListAction,
  taxCatListAction,
  uomListAction,
  vendorListAction,
} from "../../redux/actions/general-action";
import {
  fetchMdmItemAction,
  productCreateAction,
  productEditAction,
  productGenerateItemCodeAction,
  productVerifyItemCodeAction,
} from "../../redux/actions/product-action";
import MdmTab from "../../components/product-information/mdm-tab";
import TabsComponent from "../../components/helper-components/tabs-component";
import {
  cartonSearchListAction,
  compositionSearchListAction,
  packingSearchListAction,
  packingTypeSearchListAction,
  uomGroupTableListAction,
} from "../../redux/actions/settings-action";
import { handleShowErrorToast } from "../../components/helper-components/helper-function";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import DiscountTab from "../../components/product-information/discount-tab";
import MoleculeTab from "../../components/product-information/molecule-tab";
import PackingTab from "../../components/product-information/packing-tab";

const AddProduct = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const suggestedProducts = location.state?.suggestedProducts || [];
  const [searchParams] = useSearchParams();
  const itemText = searchParams.get("itemText") || "";
  const itemIndex = searchParams.get("itemIndex") || "";
  const [formValues, setFormValues] = useState({
    purchasing: null,
    sales: null,
    inventory: null,
    planning: null,
    restrictions: null,
    discount: null,
    packData: null,
  });
  const [disableItemCode, setDisableItemCode] = useState(false);
  const [catList, setCatList] = useState([]);
  const [uomList, setUomList] = useState([]);

  const [packingTypeData, setPackingTypeData] = useState([]);
  const [packingData, setPackingData] = useState([]);
  const [cartonData, setCartonData] = useState([]);

  const [packData, setPackData] = useState([]);

  const [priceList, setPriceList] = useState([]);
  const [uomGroupList, setUomGroupList] = useState([]);
  const [uomGroupData, setUomGroupData] = useState([]);
  const [uomGroupID, setUomGroupID] = useState("");
  const [itemGroup, setItemGroup] = useState([]);
  const [itemType, setItemType] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [taxListInter, setTaxListInter] = useState([]);
  const [compositionList, setCompositionList] = useState([]);

  const [manufacturesList, setManufacturesList] = useState([]);
  const [manufacturerSearch, setManufacturerSearch] = useState("");
  const [debouncedManufacturerSearch, setDebouncedManufacturerSearch] =
    useState("");
  const initialManufacturesListRef = useRef([]);
  const manufacturerSearchRef = useRef("");
  // Accumulates every manufacturer option ever seen (initial list + search
  // results) so the selected option's label can still be resolved after the
  // visible options are narrowed down to a server-side search result.
  const manufacturerOptionsMapRef = useRef({});
  const [shippingTypeList, setShippingTypeList] = useState([]);
  const [sectorList, setSectorList] = useState([]);
  const [schList, setSchList] = useState([]);
  const [currentTab, setCurrentTab] = useState("General");
  const [mdmLoading, setMdmLoading] = useState(false);
  const [mdmError, setMdmError] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [isFormSaved, setIsFormSaved] = useState(false);
  const [tabChanges, setTabChanges] = useState({
    general: false,
    packing: false,
    purchasing: false,
    sales: false,
    inventory: false,
    planning: false,
    discount: false,
    molecule: false,
    restrictions: false,
    remarks: false,
  });
  const containerRef = useRef(null);
  const [vendorList, setVendorList] = useState([]);
  const [productId, setProductId] = useState(null);
  const [item_code, setItem_code] = useState(null);
  const handleClick = (item) => {
    setCurrentTab(productId ? item : "General");
    const container = containerRef.current;
    const selectedTab = document.getElementById(item);
    if (container && selectedTab) {
      const containerWidth = container.offsetWidth;
      const selectedTabWidth = selectedTab.offsetWidth;
      const selectedTabLeft = selectedTab.offsetLeft;
      const scrollTo =
        selectedTabLeft - (containerWidth - selectedTabWidth) / 2;
      container.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });
    }
  };

  const handleTabChange = (tabName, hasChanges) => {
    setTabChanges((prev) => ({
      ...prev,
      [tabName]: hasChanges,
    }));
  };

  const getTabsWithChanges = () => {
    return Object.entries(tabChanges)
      .filter(([tab, hasChanges]) => hasChanges)
      .map(([tab]) => tab);
  };

  const showComprehensiveConfirmation = () => {
    const changedTabs = getTabsWithChanges();
    if (changedTabs.length === 0) return true;

    const tabNames = {
      general: "General Information",
      packing: "Packing Information",
      purchasing: "Purchasing Information",
      sales: "Sales Information",
      inventory: "Inventory Information",
      planning: "Planning Information",
      discount: "Discount Information",
      molecule: "Molecule Information",
      restrictions: "Restrictions Information",
      remarks: "Remarks Information",
    };

    const changedTabNames = changedTabs.map((tab) => tabNames[tab] || tab);
    const tabList = changedTabNames.join(", ");

    return window.confirm(
      `You have unsaved changes in the following sections:\n\n${tabList}\n\nAre you sure you want to navigate away without saving?`
    );
  };

  // Track back button clicks specifically
  const backButtonRef = useRef(null);

  useEffect(() => {
    const backButton = backButtonRef.current;
    if (!backButton) return;

    const handleBackClick = (event) => {
      console.log("=== BACK BUTTON CLICKED IN ADDPRODUCT ===");
      event.preventDefault(); // Prevent InnerLayout's default behavior
      event.stopPropagation(); // Stop event bubbling

      const changedTabs = getTabsWithChanges();
      if (changedTabs.length > 0) {
        const shouldNavigate = showComprehensiveConfirmation();
        if (shouldNavigate) {
          console.log("User confirmed navigation - proceeding");
          navigate(-1);
        } else {
          console.log("User cancelled navigation");
        }
      } else {
        navigate(-1);
      }
    };

    backButton.addEventListener("click", handleBackClick);

    return () => {
      backButton.removeEventListener("click", handleBackClick);
    };
  }, [hasUnsavedChanges, navigate]);

  // Block browser refresh/close when there are unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  // Debug: Monitor hasUnsavedChanges state
  useEffect(() => {
    console.log("=== HAS UNSAVED CHANGES STATE ===");
    console.log("hasUnsavedChanges:", hasUnsavedChanges);
    console.log("Current tab:", currentTab);
  }, [hasUnsavedChanges, currentTab]);

  // Component to track form changes
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      // Don't track changes if form was just saved
      if (isFormSaved) {
        console.log("=== FORM CHANGE TRACKER ===");
        console.log("Form was saved, not tracking changes");
        setHasUnsavedChanges(false);
        handleTabChange("general", false);
        return;
      }

      const hasChanges =
        JSON.stringify(initialValues) !== JSON.stringify(values);
      console.log("=== FORM CHANGE TRACKER ===");
      console.log("Form change detected:", hasChanges);
      console.log("Initial values:", initialValues);
      console.log("Current values:", values);
      console.log("Setting hasUnsavedChanges to:", hasChanges);

      // If there are changes, reset the saved flag
      if (hasChanges) {
        setIsFormSaved(false);
      }

      setHasUnsavedChanges(hasChanges);
      handleTabChange("general", hasChanges);
    }, [values, initialValues, isFormSaved]);

    return null;
  };

  const onPackingSuccess = (data) => {
    setPackingData(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };

  const onPackingTypeSuccess = (data) => {
    setPackingTypeData(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onCartonSuccess = (data) => {
    setCartonData(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  useEffect(() => {
    dispatch(cartonSearchListAction("", onCartonSuccess, onError));
    dispatch(packingSearchListAction("", onPackingSuccess, onError));
    dispatch(packingTypeSearchListAction("", onPackingTypeSuccess, onError));

    dispatch(vendorListAction(onVendorSuccess, onVendorError));
    dispatch(catListAction(onCatSuccess, onCatError));
    dispatch(uomListAction(onUomSuccess, onUomError));
    dispatch(priceListAction(onpriceSuccess, onpriceError));
    dispatch(taxCatListAction(ontaxCatSuccess, ontaxCatError));
    dispatch(interTaxCatListAction(onIntertaxCatSuccess, onIntertaxCatError));
    // dispatch(
    //   compositionSearchListAction("", onCompositionSuccess, onCompositionError)
    // );
    dispatch(
      manufacturesListAction(onmanufacturesSuccess, onmanufacturesError)
    );
    dispatch(
      shippingTypeListAction(onshippingTypeSuccess, onshippingTypeError)
    );
    dispatch(itemGroupListAction(onitemGroupSuccess, onitemGroupError));
    dispatch(itemTypeListAction(onitemTypeSuccess, onitemTypeError));
    dispatch(sectorListAction(onsectorSuccess, onsectorError));
    dispatch(schListAction(onschSuccess, onschError));
    // dispatch(uomGroupListAction(onUomGrpSuccess, onUomGrpError));

    dispatch(
      uomGroupTableListAction(
        {},
        onFetchUomGroupListSuccess,
        onFetchUomGroupListError
      )
    );
  }, []);

  const onCompositionSuccess = (data) => {
    setCompositionList(
      data?.data?.map((item) => {
        return { label: item?.code, value: item?.id };
      })
    );
  };
  const onCompositionError = (data) => {
    errorToast(data?.data?.message || "Could not fetch molecule composition");
  };

  const onFetchUomGroupListSuccess = (data) => {
    setUomGroupData(data?.data?.uomList);

    // setUomGroupList(
    //   data?.data?.uomList?.map((item) => {
    //     return {
    //       label: item?.name,
    //       value: item?.group_id,
    //       packSize: item?.group_items?.reduce(
    //         (acc, item2) => {
    //           const quantityText = `${item2?.sub_quantity ?? ""} ${
    //             item2?.sub_uom_name ?? ""
    //           }`.trim();

    //           if (item2?.pack_description === "primary") {
    //             acc.primary = quantityText;
    //             acc.primaryID = item2?.item_id;
    //           }
    //           if (item2?.pack_description === "secondary") {
    //             acc.secondary = quantityText;
    //             acc.secondaryID = item2?.item_id;
    //           }
    //           if (item2?.pack_description === "tertiary") {
    //             acc.tertiary = quantityText;
    //             acc.tertiaryID = item2?.item_id;
    //           }

    //           return acc;
    //         },
    //         { primary: "", secondary: "", tertiary: "" }
    //       ),
    //     };
    //   })
    // );

    setUomGroupList(
      data?.data?.uomList?.map((item) => {
        return {
          label: item?.name,
          value: item?.group_id,
          packSize: item?.group_items?.reduce(
            (acc, item2) => {
              const quantityText = item2?.sub_quantity ?? "";

              if (item2?.pack_description === "primary") {
                acc.primary = quantityText;
                acc.primaryID = item2?.item_id;
              }
              if (item2?.pack_description === "secondary") {
                acc.secondary = quantityText;
                acc.secondaryID = item2?.item_id;
              }
              if (item2?.pack_description === "tertiary") {
                acc.tertiary = quantityText;
                acc.tertiaryID = item2?.item_id;
              }

              return acc;
            },
            { primary: "", secondary: "", tertiary: "" }
          ),
        };
      })
    );
  };

  const onFetchUomGroupListError = (data) => {
    setUomGroupData([]);
    errorToast(data?.message);
  };

  // const onUomGrpError = (data) => {
  //   errorToast(data?.message);
  // };
  // const onUomGrpSuccess = (data) => {
  //   setUomGroupList(
  //     data?.data?.map((item) => {
  //       return { label: item?.name, value: item?.group_id };
  //     })
  //   );
  // };
  const onVendorSuccess = (data) => {
    setVendorList(
      data?.data?.vendors?.map((item) => {
        return { label: item?.vendors, value: item?.id };
      })
    );
  };
  const onVendorError = (data) => {
    errorToast(data?.message);
  };
  const onCatSuccess = (data) => {
    setCatList(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onCatError = (data) => {
    // errorToast(data?.message);
  };
  const onUomSuccess = (data) => {
    setUomList(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onUomError = (data) => {
    setUomList([]);
  };
  const onpriceSuccess = (data) => {
    setPriceList(
      data?.data?.map((item) => {
        return { label: item?.price_list_name, value: item?.price_list_id };
      })
    );
  };
  const onpriceError = (data) => {
    // errorToast(data?.message);
  };
  const ontaxCatSuccess = (data) => {
    setTaxList(
      data?.data?.map((item) => {
        return { label: item?.code, value: item?.id };
      })
    );
  };

  const ontaxCatError = (data) => {
    // errorToast(data?.message);
  };
  const onIntertaxCatSuccess = (data) => {
    setTaxListInter(
      data?.data?.map((item) => {
        return { label: item?.code, value: item?.id };
      })
    );
  };
  const onIntertaxCatError = (data) => {
    //errorToast(data?.message);
  };
  const onmanufacturesSuccess = (data) => {
    const list =
      data?.data?.map((item) => ({
        label: item?.name,
        value: item?.id,
      })) || [];
    initialManufacturesListRef.current = list;
    list.forEach((option) => {
      manufacturerOptionsMapRef.current[option.value] = option;
    });
    // Skip if the user already typed a manufacturer search before this
    // (slower) initial full-list request resolved — don't clobber their results.
    if (!manufacturerSearchRef.current.trim()) {
      setManufacturesList(list);
    }
  };
  const onmanufacturesError = (data) => {
    setManufacturesList([]);
  };

  const onManufacturerSearchSuccess = (data) => {
    const list = Array.isArray(data?.data) ? data.data : data?.data?.data || [];
    const options = list.map((item) => ({
      label: item?.name,
      value: item?.id,
    }));
    options.forEach((option) => {
      manufacturerOptionsMapRef.current[option.value] = option;
    });
    setManufacturesList(options);
  };
  const onManufacturerSearchError = () => {
    setManufacturesList([]);
    errorToast("Failed to search manufacturers");
  };
  const handleManufacturerSearchInput = (text) => {
    manufacturerSearchRef.current = text;
    setManufacturerSearch(text);
  };
  const resetManufacturerSearch = () => {
    manufacturerSearchRef.current = "";
    setManufacturerSearch("");
    setDebouncedManufacturerSearch("");
    setManufacturesList(initialManufacturesListRef.current);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedManufacturerSearch(manufacturerSearch);
    }, 400);
    return () => clearTimeout(timer);
  }, [manufacturerSearch]);

  useEffect(() => {
    const query = debouncedManufacturerSearch.trim();
    // Wait for at least 2 characters before hitting the search API — the
    // backend rejects shorter terms, which was surfacing as "no results".
    if (query.length < 2) {
      setManufacturesList(initialManufacturesListRef.current);
      return;
    }
    dispatch(
      manufacturerFuzzySearchAction(
        { q: query, limit: 10, offset: 0 },
        onManufacturerSearchSuccess,
        onManufacturerSearchError
      )
    );
  }, [debouncedManufacturerSearch]);
  const onshippingTypeSuccess = (data) => {
    setShippingTypeList(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onshippingTypeError = (data) => {
    setShippingTypeList([]);
  };
  const onitemGroupSuccess = (data) => {
    setItemGroup(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onitemGroupError = (data) => { };
  const onitemTypeSuccess = (data) => {
    setItemType(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onitemTypeError = (data) => { };
  const onsectorSuccess = (data) => {
    setSectorList(
      data?.data?.sector?.map((item) => {
        return { label: item?.sector, value: item?.sector };
      })
    );
  };
  const onsectorError = (data) => {
    // errorToast(data?.message);
  };
  const onschSuccess = (data) => {
    setSchList(
      data?.data?.scheduleList?.map((item) => {
        return { label: item?.schedule, value: item?.schedule };
      })
    );
  };
  const onschError = (data) => {
    // errorToast(data?.message);
  };
  // const onGenerateItemCodeSuccess = (data) => {
  //     console.log(data.data.item_code);
  //     const item_code = Number(data.data.item_code);
  //     setItem_code(item_code);
  //     setFieldValue('item_code', item_code)
  // }
  // const onGenerateItemCodeError = (data) => {
  //     console.log(data);
  // }
  const onVerifyItemCodeSuccess = (data) => {
    const exists = data?.data?.exists;
    console.log(data?.data?.exists);
    if (exists) {
      //Show error
      errorToast("Item Code already exists");
      setItem_code(null);
    } else {
      //We can go ahead all good
    }
  };
  const onVerifyItemCodeError = (data) => {
    console.log(data);
  };

  const initialValues = {
    item_type: "",
    item_code: "",
    item_name: itemText ?? "",
    item_categeory: "",
    item_price_list: "",
    item_group: "",
    item_generic_name: "",
    item_barcode: "",
    item_uom: "",
    item_billing_uom_name: "",
    item_billing_uom_name_id: "",
    item_unit_price: null,
    item_description: "",
    is_inventory_item: false,
    is_purchase_item: false,
    is_sales_item: false,
    item_manufacturer: "",
    item_shipping_type: "",
    item_sector: "",
    item_schedule: "",
    // item_gst: false,
    item_hsn: "",
    item_tax_category: "",
    item_inter_tax_category: "",
    item_remarks: "",
    country: "",
    // manage_item_by: "",
    active_from: null,
    active_to: null,
    inactive_from: null,
    inactive_to: null,
    is_active: true,
    // molecule_composition:[]
    mdm_code: "",
    mdm_existing_dc: "",
    mdm_division_code: "",
    mdm_division_name: "",
    mdm_segment_name: "",
    mdm_family_name: "",
    mdm_family_code: "",
    mdm_class_name: "",
    mdm_class_code: "",
    mdm_item_type: "",
    mdm_uom: "",
    mdm_pack_size: "",
    mdm_dosage_from: "",
    mdm_costing_method: "",
    mdm_batch: "",
    mdm_expiry_date: "",
    mdm_expiry_shelf_life: "",
    mdm_description1: "",
    mdm_description2: "",
    mdm_description3: "",
    mdm_description4: "",
    mdm_description5: "",
    mdm_description6: "",
    mdm_rating: "",
  };
  const validationSchema = Yup.object().shape({
    item_code: Yup.number().required("item code is required"),
    item_name: Yup.string().required("product name is required"),
    item_hsn: Yup.string()
      .required("HSN code is required") // Added required validation
      .matches(hsnRegExp, "Invalid HSN code"),
    // item_unit_price: Yup.number(),
    item_uom: Yup.string().required("uom is required"),
    item_tax_category: Yup.string().required("tax category is required"),
    item_inter_tax_category: Yup.string().required("Inter tax category is required")
  });
  const onSubmit = (values, actions) => {
    if (JSON.stringify(initialValues) === JSON.stringify(values)) {
      return errorToast("No changes");
    }
    let actionType = productCreateAction;
    if (productId) {
      actionType = productEditAction;
    }

    const submittedValues = {
      ...values,
      item_id: productId,
    };

    // Deleting the unnecessary key
    delete submittedValues.auto_generate_code;
    delete values.auto_generate_code;

    dispatch(
      actionType(productId ? submittedValues : values, onSuccess, onError)
    );
    actions.setSubmitting(false);
    // Reset unsaved changes after successful submission
    setHasUnsavedChanges(false);
  };

  const onSuccess = (data) => {
    setProductId(data?.data?.item_id);
    setItem_code(data?.data?.item_code);
    setUomGroupID(data?.data?.item_uom);
    setCurrentTab("Packing Information");

    // Mark form as saved and reset unsaved changes
    setIsFormSaved(true);
    setHasUnsavedChanges(false);

    console.log("=== FORM SAVED ===");
    console.log("isFormSaved set to true");
    console.log("hasUnsavedChanges set to false");
    console.log("Navigation should now be allowed");

    successToast("Product created Successfully");
  };

  const onError = (data) => {
    console.log(data, "dfsddsfdsfdsfs");
    errorToast(data?.data?.message);
  };

  const verifyItemCode = (ItemCode) => {
    //Call the api to verify the entered Item Code
    if (ItemCode) {
      console.log("Verify Triggered");
      dispatch(
        productVerifyItemCodeAction(
          { item_code: ItemCode },
          onVerifyItemCodeSuccess,
          onVerifyItemCodeError
        )
      );
    }
  };

  return (
    <InnerLayout backBtn={true} title="Add Item" backButtonRef={backButtonRef}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, errors }) => {
          const generateItemCode = () => {
            // Call the API to generate the item code
            dispatch(
              productGenerateItemCodeAction(
                {},
                (data) => {
                  console.log("Generated Item Code:", data.data.item_code);
                  setFieldValue("item_code", data.data.item_code); // Update Formik with the generated item code
                },
                (error) => {
                  console.error("Error generating item code:", error);
                }
              )
            );
          };

          return (
            <Form className="h-full pt-5">
              <FormChangeTracker />
              <div className="flex flex-col justify-between h-full ">
                <div>
                  {" "}
                  <div>
                    <div className="flex flex-wrap mb-8">
                      <div className="w-full 2xl:w-[43%] lg:w-[60%] px-5 xl:px-10">
                        <div>
                          <InputField
                            type="number"
                            name="item_code"
                            placeholder="Enter item Code"
                            label="Item Code"
                            isRequired={true}
                            labelWidth="7rem"
                            isDisabled={disableItemCode}
                            onBlur={(ev) => {
                              verifyItemCode(ev.target.value);
                            }}
                            handleChange={(ev) => {
                              setFieldValue("item_code", item_code).then();
                            }}
                          />
                        </div>
                        <div className="flex gap-3 items-start w-full">
                          <InputField
                            containerClass="mb-2 position-relative w-full"
                            type="text"
                            name="mdm_code"
                            placeholder="Enter MDM Code"
                            label="MDM Code"
                            isRequired={false}
                            labelWidth="7rem"
                            extraAllowedChars="-"
                          />
                          <button
                            type="button"
                            disabled={mdmLoading}
                            onClick={() => {
                              const mdmCode = values.mdm_code;
                              if (!mdmCode) {
                                setMdmError("Please enter an MDM Code");
                                return;
                              }
                              setMdmLoading(true);
                              setMdmError("");
                              dispatch(
                                fetchMdmItemAction(
                                  mdmCode,
                                  (response) => {
                                    setMdmLoading(false);
                                    const d = response.data;
                                    setFieldValue("item_name", d.item_name);
                                    setFieldValue("item_description", d.item_description);
                                    setFieldValue("is_inventory_item", d.is_inventory_item);
                                    setFieldValue("item_hsn", d.item_hsn);
                                    setFieldValue("item_unit_price", d.item_unit_price);
                                    setFieldValue("mdm_code", d.mdm_code);
                                    setFieldValue("mdm_existing_dc", d.mdm_existing_dc);
                                    setFieldValue("mdm_division_code", d.mdm_division_code);
                                    setFieldValue("mdm_division_name", d.mdm_division_name);
                                    setFieldValue("mdm_segment_name", d.mdm_segment_name);
                                    setFieldValue("mdm_family_name", d.mdm_family_name);
                                    setFieldValue("mdm_family_code", d.mdm_family_code);
                                    setFieldValue("mdm_class_name", d.mdm_class_name);
                                    setFieldValue("mdm_class_code", d.mdm_class_code);
                                    setFieldValue("mdm_item_type", d.mdm_item_type);
                                    setFieldValue("mdm_uom", d.mdm_uom);
                                    setFieldValue("mdm_pack_size", d.mdm_pack_size);
                                    setFieldValue("mdm_dosage_from", d.mdm_dosage_from);
                                    setFieldValue("mdm_costing_method", d.mdm_costing_method);
                                    setFieldValue("mdm_batch", d.mdm_batch);
                                    setFieldValue("mdm_expiry_date", d.mdm_expiry_date);
                                    setFieldValue("mdm_expiry_shelf_life", d.mdm_expiry_shelf_life);
                                    setFieldValue("mdm_description1", d.mdm_description1);
                                    setFieldValue("mdm_description2", d.mdm_description2);
                                    setFieldValue("mdm_description3", d.mdm_description3);
                                    setFieldValue("mdm_description4", d.mdm_description4);
                                    setFieldValue("mdm_description5", d.mdm_description5);
                                    setFieldValue("mdm_description6", d.mdm_description6);
                                    setFieldValue("mdm_rating", d.mdm_rating);
                                  },
                                  (error) => {
                                    setMdmLoading(false);
                                    setMdmError(error?.message || "Failed to fetch from D365");
                                  }
                                )
                              );
                            }}
                            className="p-3 rounded-md bg-D5E6Ff whitespace-nowrap text-sm"
                          >
                            {mdmLoading ? "Fetching..." : "Fetch from D365"}
                          </button>
                        </div>
                        {mdmError && (
                          <p className="text-red-500 text-xs mb-2 ps-2">{mdmError}</p>
                        )}
                        <InputField
                          maxLength={255}
                          type="text"
                          name="item_name"
                          placeholder="Enter item name"
                          label="Item Name"
                          isRequired={true}
                          labelWidth="7rem"
                          allowSpecial={true}
                        />
                        <InputField
                          maxLength={255}
                          type="text"
                          name="item_generic_name"
                          placeholder="Enter Generic name"
                          label="Generic Name"
                          isRequired={false}
                          allowSpecial={true}
                          labelWidth="7rem"
                        />
                        <TextAreaField
                          maxLength={100}
                          label="Description"
                          placeholder="Enter Description"
                          name="item_description"
                          id={"item_description"}
                          isRequired={false}
                          labelWidth="7rem"
                          feildHeight="9rem"
                          allowSpecial={true}
                        />
                        <InputField
                          type="text"
                          name="item_barcode"
                          placeholder="Enter bar code"
                          label="Bar Code"
                          isRequired={false}
                          labelWidth="7rem"
                        />

                        {/* <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10"> */}
                        <CheckBox
                          conClass="flex flex-wrap justify-between gap-4"
                          items={itemoptions}
                        />
                        {/* </div> */}
                      </div>
                      <div className="w-full 2xl:w-[27%] lg:w-[40%] px-5 xl:px-10 mt-10 lg:mt-0">
                        <div className="flex items-center gap-2 p-2 border-width-0 rounded-lg border-white bg-white mb-5 ">
                          <CheckBox
                            items={[
                              {
                                label: "Auto Generate",
                                name: "auto_generate_code",
                                isRequired: false,
                              },
                            ]}
                            labelClassname={`text-md fw_400`}
                            onChange={(field_name, is_checked) => {
                              console.log(field_name);
                              if (
                                field_name === "auto_generate_code" &&
                                is_checked === true
                              ) {
                                generateItemCode();
                                //disable the item code input
                                setDisableItemCode(true);
                              } else if (
                                field_name === "auto_generate_code" &&
                                is_checked === false
                              ) {
                                setDisableItemCode(false);
                              }
                            }}
                          />
                        </div>
                        <SelectField
                          placeholder="Select item type"
                          options={itemType}
                          label="Item Type"
                          id="item_type"
                          name="item_type"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={false}
                          labelWidth="7rem"
                        />

                        <SelectField
                          placeholder="Select item category"
                          options={catList}
                          label="Item Category"
                          id="item_categeory"
                          name="item_categeory"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={false}
                          labelWidth="7rem"
                        />
                        <SelectField
                          placeholder="Select item group"
                          options={itemGroup}
                          label="Item Group"
                          id="item_group"
                          name="item_group"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={false}
                          labelWidth="7rem"
                        />
                        <SelectField
                          placeholder="Select Price"
                          options={priceList}
                          label="Price List"
                          id="item_price_list"
                          name="item_price_list"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={false}
                          labelWidth="7rem"
                        />

                        <SelectField
                          handleSelected={(data) => {
                            setPackData(data.packSize);
                            console.log(
                              "zzzzzzzzzzzzzzzzzzzz",
                              data,
                              data.packSize
                            );
                          }}
                          placeholder="Select uom"
                          // options={uomList}
                          options={uomGroupList}
                          label="UOM Group"
                          id="item_uom"
                          name="item_uom"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={true}
                          labelWidth="7rem"
                        />
                        <SelectField
                          handleSelected={(sel) => {
                            setFieldValue("item_billing_uom_name", sel?.label);
                          }}
                          placeholder="Select billing uom"
                          options={
                            uomGroupData
                              ?.find(
                                (grp) => grp?.group_id === values?.item_uom
                              )
                              ?.group_items?.map((uom) => ({
                                label: uom?.alt_uom,
                                value: uom?.item_id,
                              })) || []
                          }
                          label="Billing UOM"
                          id="item_billing_uom_name_id"
                          name="item_billing_uom_name_id"
                          isSearchable={true}
                          errMsgContainerClass="ps-2"
                          isRequired={false}
                          labelWidth="7rem"
                        />
                        <InputField
                          type="number"
                          name="item_unit_price"
                          placeholder="xxxxx"
                          label="Unit Price"
                          labelWidth="7rem"
                        />
                      </div>
                    </div>
                    <TabsComponent
                      handleClickfn={(item) => {
                        setCurrentTab(item);
                      }}
                      itemTabs={itemTabs}
                      setCurrentTab={setCurrentTab}
                      currentTab={currentTab}
                    />
                  </div>
                  {currentTab === "General" && (
                    <>
                      <div className="flex flex-wrap mt-3">
                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10">
                          <SelectField
                            placeholder="Select manufacturer"
                            options={manufacturesList}
                            valueOptions={Object.values(manufacturerOptionsMapRef.current)}
                            onSearchInputChange={handleManufacturerSearchInput}
                            handleSelected={resetManufacturerSearch}
                            onMenuClose={resetManufacturerSearch}
                            label="Manufacturer"
                            id="item_manufacturer"
                            name="item_manufacturer"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                          <SelectField
                            placeholder="Select sector"
                            options={sectorList}
                            label="Sector"
                            id="item_sector"
                            name="item_sector"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                          <SelectField
                            placeholder="Select SCH"
                            options={schList}
                            label="SCH"
                            id="item_schedule"
                            name="item_schedule"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                        </div>
                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 lg:mt-0">
                          <SelectField
                            placeholder="Select shipping type"
                            options={shippingTypeList}
                            label="Shipping Type"
                            id="item_shipping_type"
                            name="item_shipping_type"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                        </div>
                      </div>

                      <h2 className="text-000000 fw_500 text-sm mb-8 px-5 xl:px-10 mt-10">
                        Item Category
                      </h2>

                      <div className="flex flex-wrap mt-3">
                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10">
                          <InputField

                            type="text"
                            name="item_hsn"
                            placeholder="Enter HSN"
                            label="HSN"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                        </div>

                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 lg:mt-0">
                          <SelectField

                            placeholder="Select tax category"
                            options={taxList}
                            label="Intra Tax Category"
                            id="item_tax_category"
                            name="item_tax_category"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={true}
                            labelWidth="9rem"
                          />
                        </div>

                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 2xl:mt-0">
                          <SelectField

                            placeholder="Select tax category"
                            options={taxListInter}
                            label="Inter Tax Category"
                            id="item_inter_tax_category"
                            name="item_inter_tax_category"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={true}
                            labelWidth="9rem"
                          />
                        </div>

                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10">
                          <InputField

                            type="text"
                            name="item_remarks"
                            placeholder="Enter remarks"
                            label="Remarks"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                        </div>

                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 lg:mt-0">
                          <SelectField

                            placeholder="Select country"
                            options={[{ label: "India", value: "india" }]}
                            label="Country"
                            id="country"
                            name="country"
                            isSearchable={true}
                            errMsgContainerClass="ps-2"
                            isRequired={false}
                            labelWidth="7rem"
                          />
                        </div>
                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 2xl:mt-0" />
                      </div>
                      <div className="flex flex-wrap my-5">
                        <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10">
                          <div className="flex flex-wrap items-center justify-between">
                            <div className="w-full xl:w-[30%]">
                              <RadioButton
                                inputLabelClass="ms-2"
                                onChange={(e) => {
                                  setFieldValue("active_from", null);
                                  setFieldValue("active_to", null);
                                  setFieldValue("inactive_from", null);
                                  setFieldValue("inactive_to", null);
                                  const { value } = e.target;
                                  setFieldValue(
                                    "is_active",
                                    value === "false" ? false : true
                                  );
                                }}
                                labelClass="color_9E9E9E d-flex text-sm mb-1 "
                                name="is_active"
                                options={activeOptns}
                                label=""
                              />
                            </div>
                            <div className="w-full xl:w-[60%] mt-5 xl:mt-0">
                              <InputField
                                errMsgContainerClass="hidden"
                                type="date"
                                name={`${values?.is_active
                                  ? "active_from"
                                  : "inactive_from"
                                  }`}
                                placeholder=""
                                label="From"
                                isRequired={false}
                                labelWidth="3rem"
                              />
                              <InputField
                                containerClass="mt-3"
                                errMsgContainerClass="hidden"
                                type="date"
                                name={`${values?.is_active ? "active_to" : "inactive_to"
                                  }`}
                                placeholder=""
                                label="To"
                                isRequired={false}
                                labelWidth="3rem"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {currentTab === "Packing Information" && (
                    <PackingTab
                      page="add"
                      packingData={packingData}
                      packingTypeData={packingTypeData}
                      cartonData={cartonData}
                      packData={packData}
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      vendorList={vendorList}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      uomList={uomList}
                      productId={productId}
                      setFormValues={setFormValues}
                      uomGroupID={uomGroupID}
                      uomGroupData={uomGroupData}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("packing", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Purchasing" && (
                    <PurchasingTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      vendorList={vendorList}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      uomList={uomList}
                      productId={productId}
                      setFormValues={setFormValues}
                      uomGroupID={uomGroupID}
                      uomGroupData={uomGroupData}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("purchasing", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Sales" && (
                    <SalesTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      uomList={uomList}
                      productId={productId}
                      setFormValues={setFormValues}
                      uomGroupID={uomGroupID}
                      uomGroupData={uomGroupData}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("sales", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Inventory" && (
                    <InventoryTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      uomList={uomList}
                      productId={productId}
                      setFormValues={setFormValues}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("inventory", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Planning" && (
                    <PlanningTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      productId={productId}
                      setFormValues={setFormValues}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("planning", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Discounts & Scheme" && (
                    <DiscountTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      productId={productId}
                      setFormValues={setFormValues}
                      uomGroupData={uomGroupData}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("discount", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Molecule Composition" && (
                    <MoleculeTab
                      page="add"
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      productId={productId}
                      setFormValues={setFormValues}
                      uomGroupData={uomGroupData}
                      compositionList={compositionList}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("molecule", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Restrictions" && (
                    <RestrictionsTab
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      productId={productId}
                      setFormValues={setFormValues}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("restrictions", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "Remarks" && (
                    <RemarksTab
                      uomGroupData={uomGroupData}
                      suggestedProducts={suggestedProducts}
                      itemIndex={itemIndex}
                      itemText={itemText}
                      itemGeneralData={{
                        ...values,
                        item_id: productId,
                        item_code: item_code,
                      }}
                      setCurrentTab={setCurrentTab}
                      formValues={formValues}
                      productId={productId}
                      setFormValues={setFormValues}
                      hasUnsavedChanges={hasUnsavedChanges}
                      setHasUnsavedChanges={setHasUnsavedChanges}
                      isFormSaved={isFormSaved}
                      setIsFormSaved={setIsFormSaved}
                      onTabChange={(hasChanges) =>
                        handleTabChange("remarks", hasChanges)
                      }
                    />
                  )}
                  {currentTab === "MDM" && (
                    <MdmTab values={values} />
                  )}
                  {currentTab === "General" && (
                    <div
                      style={{
                        position: "fixed",
                        bottom: "0",
                        right: "0",
                        left: "0",
                        zIndex: 10,
                      }}
                      className="flex justify-end px-10 bg-white py-4 invoice-bottom-container"
                    >
                      <AddButton
                        onclkFn={() => handleShowErrorToast(errors)}
                        prefixIcon={false}
                        text="Save"
                        type="submit"
                      />
                    </div>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </InnerLayout>
  );
};

export default AddProduct;

const items = [{ label: "All", value: "all" }];

const itemoptions = [
  { label: "Inventory Item", name: "is_inventory_item", isRequired: false },
  { label: "Purchase Item", name: "is_purchase_item", isRequired: false },
  { label: "Sales Item", name: "is_sales_item", isRequired: false },
];
const itemTabs = [
  "General",
  "Packing Information",
  "Purchasing",
  "Sales",
  "Inventory",
  "Planning",
  "Discounts & Scheme",
  "Molecule Composition",
  "Restrictions",
  "Remarks",
  "MDM",
];
export const activeOptns = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];
export const serialBatchesOptns = [
  { label: "Batches", value: "batches" },
  { label: "Numbers", value: "numbers" },
  { label: "Batches and Numbers", value: "batches_numbers" },
];
